import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-provider-header',
  templateUrl: './provider-header.component.html',
  styleUrls: ['./provider-header.component.scss']
})
export class ProviderHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
